import React, { useMemo } from "react";
import { LayoutRouteProps } from "./LayoutRoute";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Layout, LazyModuleLayout } from "@kernel/react-ui-kit";
import { LanguageSwitcher } from "../components/LanguageSwitcher";

export type StatsLayoutRouteProps = LayoutRouteProps;

export function StatsLayoutRoute({
  logo,
  customer,
  footerEnabled,
  title,
  version,
  module,
  copyRightIcon,
  headerClassname,
  footerClassname
}: StatsLayoutRouteProps) {
  const Component = React.lazy(() => import(`../${module}/index.tsx`));
  const renderHeader = useMemo(
    () => () =>
      <Header title={title} logo={logo} className={headerClassname} />,
    [title, logo, headerClassname]
  );
  const renderFooter = useMemo(
    () => () =>
      (
        <Footer
          customer={customer}
          title={title}
          version={version}
          copyRightIcon={copyRightIcon}
          className={footerClassname}
        />
      ),
    [customer, title, version, copyRightIcon, footerClassname]
  );
  return (
    <Layout
      header={renderHeader}
      footer={footerEnabled ? renderFooter : undefined}
      className="stats"
    >
      <LanguageSwitcher />
      <LazyModuleLayout
        module={module}
        component={Component}
        moduleClassName="p-0"
      />
    </Layout>
  );
}
